<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 220px; min-width: 240px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :description="itemf.approvalTime"></el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo2"
                        :refObj.sync="formInfo2.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData"
                        border
                        max-height="430"
                        style="width: 100%;"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                    <el-table-column fixed="left"
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column prop="baseAreaName" v-if="formInfo2.data.freightFlag != 1?true:false"
                                    align="center"
                                    label="区域">
                    </el-table-column>
                    <el-table-column prop="maxQuantity" v-if="formInfo2.data.freightFlag == 1?true:false"
                                    align="center"
                                    label="运输最大数量">
                    </el-table-column>
                    <el-table-column prop="minQuantity" v-if="formInfo2.data.freightFlag == 1?true:false"
                                    align="center"
                                    label="运输最小数量">
                    </el-table-column>
                    <el-table-column prop="purUnit" v-if="formInfo2.data.freightFlag != 4?true:false"
                                    align="center" width="100"
                                    label="采购单位">
                    </el-table-column>
                    <el-table-column prop="exctTaxPrice" v-if="formInfo2.data.freightFlag != 4?true:false"
                                    align="center"
                                    label="不含税单价">
                    </el-table-column>
                    <el-table-column prop="price" v-if="formInfo2.data.freightFlag != 4?true:false"
                                    align="center"
                                    label="含税单价">
                    </el-table-column>
                </el-table>
                
                <!-- 审核表单 -->
                <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                 <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                    <Boyo-Formtwo :formInfo="formInfoAuditData"
                            :refObj.sync="formInfoAuditData.ref"
                            :listTypeInfo="listTypeInfo">
                    </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'LogisticsContractDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      showAuditDataFields: false,
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '运费合同'
        ],
        showPhraseManager: false,
        newPhrase: '',
      createdBy: null, // 保存传入的制单人
      createdTime: null, // 保存传入的制单时间
      // 下拉框相关信息
      listTypeInfo: {
        purMode :[],
        publicFlag: [{ value: 0, label: '有组织' }, { value: 1, label: '无组织' }],
        transportMode:[{ value: 0, label: '未确定' }, { value: 1, label: '车运' }, { value: 2, label: '船运' }, { value: 3, label: '集装箱' }],
        partnerId:[],
        lossFlag: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
        departureIdOver:[],
        freightFlag:[{value:0,label:'区域'},{value:1,label:'重量'},{value:2,label:'广东省'}],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        processId:[],
      },
      // 表格相关
      tableInfo: {
        selection: false, // 是否显示表格单选框,
        xuhao: true,//序号显影
        selectReset: null, // 重置单选框选中
        mode: null, // 表格模板one和two两种
        data: [], // 数据
        total: 0, // 总条数
        pager: true, // 是否显示分页
        multipleSelection: [], // 表格单选框数据
        fieldList: [
          { value: "billNo",  label: "付款编号",  show: true, dropdown: true,sortable:true,fixed:'left', width: 110},
          { value: "businessType", label: "类型", show: true, dropdown: true,list:'businessType'},
          { value: "billDate",  label: "申请付款日期",  show: true, dropdown: true,sortable:true, width: 105},
          { value: 'orderBillNo',  label: '结算单号', show: true, dropdown: true, width: 105 },
          { value: 'partnerCode', label: '供应商编号', show: true, dropdown: true },
          { value: 'partnerName', label: '供应商', show: true, dropdown: true },
          { value: 'billRemark', label: '备注', show: true, dropdown: true },
          { value: "button", label: "操作", type: "slot", show: true, dropdown: true, width: 190,fixed:'right',align:'left' },
        ],
        btList: []
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id: null,
          billDate: '',
          execDate: '',
          purModeTwo:[],
          purMode:'',
          logMenuName:'',
          logMenuCode:'',
          contractId:'',
          factoryAreaId:'',
          factoryAreaCode:'',
          factoryAreaName:'',
          partnerId:'',
          departureId:'',
          departureName:'',
          partnerAddress:'',
          partnerContacts:'',
          partnerPhone:'',
          partnerIdNumber:'',
          partnerLegalPerson:'',
          recipientAddress:'',
          partnerBankId:'',
          partnerBank:'',
          partnerBankAccount:'',
          partnerBankName:'',
          publicFlag:'',
          contractBeginDate:'',
          contractEndDate:'',
          employeeId:'',
          employeeName:'',
          transportMode:'',
          taxRate:'',
          taxRateTwo:'',
          lossFlag:'',
          lossRate:'',
          lossRateTwo:'',
          freightFlag:'',
          contractNote:'',
          freeItem1:'',
          freeItem2:'',
          departureName:'',
        },
        list: [
          {type: "dateDay",label: "单据日期：",value: "billDate", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "date",label: "执行时间：",value: "execDate", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "selectMany采购模式：",label: "采购模式：",value: "purModeTwo", style: 'width:95%', className: 'form_item_three',list:'purMode',disabled:true},
          {type: "text",label: "合同编号：",value: "contractId", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "所属单位：",value: "factoryAreaName", style: 'width:95%', className: 'form_item_three',disabled:true},
          // {type:"selectMany场地：",label: "场地：",value: "departureIds", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "select承运商：",label: "承运商：",value: "partnerId", style: 'width:95%', className: 'form_item_three',list:'partnerId',disabled:true},
          {type: "selectMany场地：",label: "场地：",value: "departureIds",list: "departureIdOver", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "承运商地址：",value: "partnerAddress", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "承运联系人：",value: "partnerContacts", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "numberPhone",label: "承运商电话：",value: "partnerPhone", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "承运商法人：",value: "partnerLegalPerson", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "身份证/税号：",value: "partnerIdNumber", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: 'text', label: '承运商银行：', value: 'partnerBank', style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "银行账号：",value: "partnerBankAccount", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "text",label: "账号户名：",value: "partnerBankName", style: 'width:95%', className: 'form_item_three',disabled:true},
          {type: "select有组织/无组织：",label: "有组织/无组织：",value: "publicFlag", style: 'width:95%', className: 'form_item_three',list:'publicFlag',disabled:true},
          {type: "period2",label: "合同有效期：",value1: "contractBeginDate",value2: "contractEndDate", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "select运输方式：",label: "运输方式：",value: "transportMode", style: 'width:95%', className: 'form_item_three',list:'transportMode',disabled:true},
          {type: "float",label: "税率%：",value: "taxRateTwo",input:'taxRateTwo', style: 'width:99%', className: 'form_item_three',disabled:true},
          {type: "select是否赔付：",label: "是否赔付：",value: "lossFlag", style: 'width:95%', className: 'form_item_three',list:'lossFlag',disabled:true},
          {type: "float",label: "赔付率%：",value: "lossRateTwo",input:'lossRateTwo', style: 'width:99%', className: 'form_item_three',shows:true,show:true,disabled:true},
          {type: "select运费方式：",label: "运费方式：",value: "freightFlag", style: 'width:95%', className: 'form_item_three',list:'freightFlag',disabled:true},
          {type: "text",label: "合同备注：",value: "contractNote", style: 'width:99%', className: 'form_item_two',disabled:true},
          { type: 'uploadThree', label: '附件：', value: 'freeItem1', style: 'width:95%;margin-top: -90px;', className: 'form_item_three',fileListHt:[],disabled:true},
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1350px', // 宽度
            title: {
                add: '运费合同对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
        formInfoAuditData: {
          ref: null,
          labelWidth: '100px',
          data: {
            id:'',
            factoryAreaId:'',
            factoryAreaCode:'',
            factoryAreaName:'',
            processId:'',
            remark:'',
            status:'',
          },
          list: [
            { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
            { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
            { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
          ],
          rules: {
            status:[{ required: true, trigger: 'change',message: '请选择' }]
          }
        },
    }
  },
  created () {
  },
  mounted () {
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
    this.$api.departure.getPurDepartPlacePage({pageNum: 1, pageSize: 999,forbidStatus:0,auditFlag:1}).then(res => {//废钢供应商等级
        if(res.code == 0) {
            let list2 = res.data.list
            for( let i in list2 ) {
                this.listTypeInfo.departureIdOver.push({value: list2[i].id, label: list2[i].dName,dNameEng:list2[i].dNameEng})
            }
        }
    })
    this.$api.Customer.getBasePartnerPage({pageNum: 1, pageSize: 0,status:0,auditStatus:1,carrierFlag:1}).then(res => {//承运商
        if(res.code == 0) {
            let list5 = res.data.list
            for( let i in list5 ) {
              if (!this.listTypeInfo.partnerId.some(oiu=>oiu.value == list5[i].partnerId)) {
                this.listTypeInfo.partnerId.push({value: list5[i].partnerId, label: list5[i].partnerName,partnerName:list5[i].partnerName,factoryAreaId:list5[i].factoryAreaId,corporateRepresentative:list5[i].corporateRepresentative,partnerAreaName:list5[i].partnerAreaName,phone:list5[i].phone,address:list5[i].address,payeeId:list5[i].payeeId,payeeName:list5[i].payeeName,recipientId:list5[i].recipientId,recipientName:list5[i].recipientName,purPaymentCondit:list5[i].purPaymentCondit,purPaymentConditEng:list5[i].purPaymentConditEng,purPaymentMode:list5[i].purPaymentMode,scrapIronFlag:list5[i].scrapIronFlag,departureId:list5[i].departureId,purQuantityMax:list5[i].purQuantityMax,site:list5[i].site,principal:list5[i].principal,idCard:list5[i].idCard,ratepayerNo:list5[i].ratepayerNo,idCardImageA:list5[i].idCardImageA,idCardImageB:list5[i].idCardImageB,bankCardImageA:list5[i].bankCardImageA,bankCardImageB:list5[i].bankCardImageB})
              }
            }
        }
    })
    // 获取流程枚举
    this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for( let i in list1 ) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
  },
  methods: {
    dialogShow(data,val,parm,id, maker, makerTime){
        this.billId = data
        this.dataId = id
        // 保存传入的制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditDataFields = true
          
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfoAuditData.data) {
              this.formInfoAuditData.data[key] = ''
            }
            
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfoAuditData.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfoAuditData.data.processId = parm.processId;
              }
              
              this.formInfoAuditData.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditDataFields = false
        }
        this.getInfo(val)
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  this.activeList.push({processNodeName:(res.data.list[i].processNodeName?res.data.list[i].processNodeName:'流程节点名称暂无') + (res.data.list[i].status?'(审核完成)':'(未完成)'),approvalTime:res.data.list[i].status?(res.data.list[i].actualApprover + ' ' + res.data.list[i].approvalTime):(res.data.list[i].approver?('审批人：' + res.data.list[i].approver):('审批角色：' + res.data.list[i].roleName))})
              }
              
              // 始终在最前面插入"制单人"节点
              // 优先使用传入的制单人和时间，如果没有则尝试使用val中的数据
              let maker = this.createdBy || (val && val.createBy ? val.createBy : '暂无');
              let makerTime = this.createdTime || (val && val.createTime ? val.createTime : '');
              let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.OrderPurchase.getPurLogisticsPage({id:this.billId,pageNum:1,pageSize:0}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                    if(key != 'purModeTwo'){
                        this.formInfo2.data[key] = ''
                    }
                }
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                // 修复后的代码
if (this.detailDate.departureIdsStr) {
  this.formInfo2.data.departureIds = this.detailDate.departureIdsStr.split(',')
} else if (this.detailDate.departureIds) {
  // 如果后端返回的是字符串格式的 departureIds
  this.formInfo2.data.departureIds = typeof this.detailDate.departureIds === 'string' 
    ? this.detailDate.departureIds.split(',') 
    : this.detailDate.departureIds
} else {
  this.formInfo2.data.departureIds = []
}
                this.formInfo2.list.forEach(iuy=>{
                    if(iuy.label == '赔付率%：' && this.detailDate.lossFlag == 0){
                      iuy.show = false
                    } else if(iuy.label == '赔付率%：' && this.detailDate.lossFlag == 1){
                      iuy.show = true
                    }
                })
                this.formInfo2.data.purModeTwo = this.detailDate.purMode.split(',')
                this.formInfo2.data.purModeTwo.forEach((iuy,l)=>{
                  this.formInfo2.data.purModeTwo[l] = Number(this.formInfo2.data.purModeTwo[l])
                })
                this.formInfo2.data.taxRateTwo = this.formInfo2.data.taxRate?(Number(this.formInfo2.data.taxRate)*100).toFixed(0):0
                this.formInfo2.data.lossRateTwo = this.formInfo2.data.lossRate?(Number(this.formInfo2.data.lossRate)*100).toFixed(0):0
                if (this.formInfo2.list[this.formInfo2.list.length - 1]) {
                    this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = []
                    if (this.detailDate.freeItem1) {
                        this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = [{name: (this.detailDate.freeItem1.split('-').length > 2)?this.detailDate.freeItem1.split('-')[2]:this.detailDate.freeItem1.split('-')[1],url: this.detailDate.freeItem1}]
                    }
                }
                this.$api.OrderPurchase.getPurLogisticsEntryPage({idLogistics:this.detailDate.id,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data.list
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfoAuditData.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfoAuditData.data.processId,
                    status: this.formInfoAuditData.data.status,
                    remark: this.formInfoAuditData.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                      dialogInfoData.btList[0].loading = false
                      if (res.code === 0) {
                          this.$message({ message: res.msg, type: 'success' })
                          dialogInfoData.visible = false
                          // this.$emit('approvalInfo')
                      } else {
                          this.$message({ message: res.msg, type: 'error' })
                      }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/LogisticsContractDialog.vue